import { render, staticRenderFns } from "./StudentCourseAndUserAdd.vue?vue&type=template&id=3b918f2c"
import script from "./StudentCourseAndUserAdd.vue?vue&type=script&lang=js"
export * from "./StudentCourseAndUserAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports